import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BrandMark from '../components/BrandMark';

const P  = "'JetBrains Mono', monospace";
const D  = "'Archivo', sans-serif";
// Light-theme palette — cyan on white fails AA, use accent-on-light (#00A8B4)
const C  = '#00A8B4';   // --accent-on-light
const BG = '#F3F6F7';   // light surface
const TEXT      = '#0A1214';  // near-black for light bg
const TEXT_MID  = '#2E4248';  // body text on light
const TEXT_DIM  = '#5A7078';  // muted label on light
// Hero keeps dark treatment — explicit dark palette for hero section only
const HERO_BG   = '#04070A';
const HERO_TEXT = '#F2F6F7';
const HERO_MID  = 'rgba(220,235,235,0.85)';

// ── Helpers ───────────────────────────────────────────────────────────────────
const Label = ({ children, style = {} }) => (
  <div style={{ fontFamily: P, fontSize: 12, fontWeight: 700, letterSpacing: '0.18em', color: C, marginBottom: 12, ...style }}>
    {children}
  </div>
);

const Brackets = ({ size = 20, color = `${C}55` }) => (
  <>
    {[['top','left'],['top','right'],['bottom','left'],['bottom','right']].map(([v,h]) => (
      <div key={v+h} style={{ position:'absolute', [v]:-1, [h]:-1, width:size, height:size,
        [`border${v[0].toUpperCase()+v.slice(1)}`]:`1.5px solid ${color}`,
        [`border${h[0].toUpperCase()+h.slice(1)}`]:`1.5px solid ${color}`,
        pointerEvents:'none' }} />
    ))}
  </>
);

// ── Nav ───────────────────────────────────────────────────────────────────────
function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);
  return (
    <nav style={{ position:'fixed', top:0, left:0, right:0, zIndex:100, display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 32px', height:64, background: scrolled ? 'rgba(243,246,247,0.97)' : 'transparent', borderBottom: scrolled ? `1px solid ${C}33` : '1px solid transparent', transition:'all 0.25s', backdropFilter: scrolled ? 'blur(16px)' : 'none' }}>
      <div style={{ display:'flex', alignItems:'center', gap:12 }}>
        <BrandMark size={30} variant="on-light" />
        <span style={{ fontFamily:D, fontWeight:900, fontStyle:'italic', fontSize:20, letterSpacing:'0.08em', color:C }}>CRIT ROSTER</span>
      </div>
      <div style={{ display:'flex', gap:10, alignItems:'center' }}>
        <Link to="/login" style={{ fontFamily:P, fontSize:12, fontWeight:700, letterSpacing:'0.12em', color:TEXT_MID, textDecoration:'none', padding:'7px 16px' }}
          onMouseEnter={e=>e.target.style.color=C} onMouseLeave={e=>e.target.style.color=TEXT_MID}>LOGIN</Link>
        <Link to="/login" style={{ fontFamily:P, fontSize:12, fontWeight:700, letterSpacing:'0.12em', color:'#ffffff', background:C, padding:'9px 20px', textDecoration:'none', display:'block' }}>
          KOSTENLOS →
        </Link>
      </div>
    </nav>
  );
}

// ── Hero ──────────────────────────────────────────────────────────────────────
function Hero() {
  return (
    <section style={{ position:'relative', minHeight:'100vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', textAlign:'center', padding:'100px 24px 80px', overflow:'hidden', background:HERO_BG }}>
      <div style={{ position:'absolute', inset:0, backgroundImage:`url('https://lh3.googleusercontent.com/aida-public/AB6AXuCZe2TP6goB8wsrWIPPQUE22GhyGTyhFM1-Lgo_b47r4i9b1LnKl2HoU0jECZerAGh34DEYfVhL0tIl2yWNkv_4tazb5XMa01QQDMqxoZKhqnp0kyW_ZfR7RsnCZOS5ZeOcDLmqAWHeQNuqhC1vdFHtcYgr725CTtbleWaP4GSDN6CrQQUtim7VM0mT4I5T3LAFtCth0nfclNmttP719OwX2FRbszVn3hlDJBSa_xA9TuQUUKODjTTy10cRakUw1MM-dQ2zZi9-Jsc')`, backgroundSize:'cover', backgroundPosition:'center top', filter:'grayscale(0.45) brightness(0.22)', transform:'scale(1.04)' }} />
      <div style={{ position:'absolute', inset:0, background:`radial-gradient(ellipse at 50% 40%, rgba(4,7,10,0.2) 0%, rgba(4,7,10,0.72) 55%, rgba(4,7,10,1) 100%)` }} />
      <div style={{ position:'absolute', inset:0, backgroundImage:`linear-gradient(${C}05 1px,transparent 1px),linear-gradient(90deg,${C}05 1px,transparent 1px)`, backgroundSize:'60px 60px', pointerEvents:'none' }} />

      <div style={{ position:'relative', zIndex:1, maxWidth:900 }}>
        <h1 style={{ fontFamily:D, fontWeight:900, fontStyle:'italic', fontSize:'clamp(52px, 10vw, 110px)', letterSpacing:'-0.02em', lineHeight:0.9, textTransform:'uppercase', margin:'0 0 36px', color:HERO_TEXT }}>
          Kein Chaos.<br />
          <span style={{ color:C, textShadow:`0 0 50px ${C}99` }}>Nur Rennen.</span>
        </h1>

        <p style={{ fontFamily:D, fontWeight:700, fontStyle:'italic', fontSize:'clamp(18px, 2.5vw, 26px)', color:HERO_MID, lineHeight:1.5, maxWidth:680, margin:'0 auto 48px', letterSpacing:'0.01em' }}>
          Team-Management für Criterium-Teams. Race Matrix, automatische Punkteübersicht, Push-Notifications — alles in einem Tool.
        </p>

        <div style={{ display:'flex', gap:14, justifyContent:'center', flexWrap:'wrap', marginBottom:56 }}>
          <Link to="/login" style={{ fontFamily:P, fontSize:14, fontWeight:700, letterSpacing:'0.14em', background:C, color:'#ffffff', padding:'18px 40px', textDecoration:'none', boxShadow:`0 0 40px ${C}55`, display:'inline-block' }}>
            KOSTENLOS STARTEN →
          </Link>
          <a href="/t/sturmvogel-demo" style={{ fontFamily:P, fontSize:14, fontWeight:700, letterSpacing:'0.14em', background:'transparent', color:HERO_TEXT, padding:'18px 40px', textDecoration:'none', border:`1px solid rgba(220,235,235,0.3)`, display:'inline-block' }}>
            DEMO ANSEHEN
          </a>
        </div>

        {/* Trust badges */}
        <div style={{ display:'flex', gap:0, justifyContent:'center', flexWrap:'wrap', border:`1px solid ${C}33`, background:'rgba(4,7,10,0.6)', backdropFilter:'blur(8px)', maxWidth:640, margin:'0 auto' }}>
          {[
            ['Kostenlos', 'Kein Kreditkartenzwang'],
            ['3 Minuten', 'bis zum ersten Event'],
            ['100%', 'Made for Crit Teams'],
          ].map(([val, label], i) => (
            <div key={i} style={{ flex:1, minWidth:160, textAlign:'center', padding:'20px 16px', borderRight: i < 2 ? `1px solid ${C}22` : 'none' }}>
              <div style={{ fontFamily:D, fontWeight:900, fontStyle:'italic', fontSize:28, color:C, lineHeight:1 }}>{val}</div>
              <div style={{ fontFamily:P, fontSize:11, color:'rgba(185,210,210,0.65)', letterSpacing:'0.08em', marginTop:6 }}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ position:'absolute', bottom:32, left:'50%', transform:'translateX(-50%)', display:'flex', flexDirection:'column', alignItems:'center', gap:6, opacity:0.4 }}>
        <div style={{ fontFamily:P, fontSize:9, letterSpacing:'0.2em', color:'#849495' }}>SCROLL</div>
        <div style={{ width:1, height:36, background:`linear-gradient(${C}, transparent)` }} />
      </div>
    </section>
  );
}

// ── Problem Strip ─────────────────────────────────────────────────────────────
function ProblemStrip() {
  const items = [
    '"Wer fährt Sonntag mit?"',
    'WhatsApp-Gruppe',
    'Excel-Sheet',
    'Daumendrücken',
  ];
  return (
    <section style={{ background:'#E8EEEF', borderTop:`1px solid ${C}22`, borderBottom:`1px solid ${C}22`, padding:'28px 24px' }}>
      <div style={{ maxWidth:1000, margin:'0 auto', display:'flex', alignItems:'center', gap:0, flexWrap:'wrap', justifyContent:'center' }}>
        <div style={{ fontFamily:P, fontSize:12, fontWeight:700, letterSpacing:'0.16em', color:TEXT_DIM, marginRight:28, whiteSpace:'nowrap' }}>KENNT IHR DAS?</div>
        {items.map((item, i) => (
          <React.Fragment key={i}>
            <div style={{ padding:'10px 22px' }}>
              <span style={{ fontFamily:P, fontSize:13, color:TEXT_MID, letterSpacing:'0.04em' }}>{item}</span>
            </div>
            {i < items.length - 1 && <div style={{ width:1, height:22, background:'rgba(90,112,120,0.3)' }} />}
          </React.Fragment>
        ))}
        <div style={{ padding:'10px 22px', marginLeft:8 }}>
          <span style={{ fontFamily:P, fontSize:13, fontWeight:700, color:C, letterSpacing:'0.08em' }}>→ GIBT EINE BESSERE LÖSUNG</span>
        </div>
      </div>
    </section>
  );
}

// ── Race Matrix (interactive mock) ────────────────────────────────────────────
const COLORS = ['#00A8B4','#ABD600','#FF9A1F','#C084FC','#F472B6','#34D399'];

function RaceMatrixSection() {
  const initialEvents = [
    { id:0, name:'MÜNSTER CRITERIUM',   date:'08. AUG · SA', drivers:['AK','ML','TR','SP','KH'],     myStatus:'confirmed' },
    { id:1, name:'DORTMUND GRAND PRIX', date:'15. AUG · SA', drivers:['AK','ML','TR'],               myStatus:'none'      },
    { id:2, name:'KÖLN CITY RACE',      date:'22. AUG · SA', drivers:['ML','TR','SP','KH','JB','AK'],myStatus:'confirmed' },
  ];
  const [events, setEvents] = useState(initialEvents);

  const toggle = (id) => {
    setEvents(ev => ev.map(e => e.id === id
      ? { ...e, myStatus: e.myStatus === 'confirmed' ? 'none' : 'confirmed' }
      : e
    ));
  };

  return (
    <section style={{ padding:'110px 24px', background:'#FFFFFF', position:'relative', overflow:'hidden' }}>
      <div style={{ position:'absolute', top:0, right:0, width:'40%', height:'100%', background:`radial-gradient(ellipse at 80% 50%,${C}12 0%,transparent 65%)`, pointerEvents:'none' }} />
      <div style={{ maxWidth:1040, margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(340px, 1fr))', gap:64, alignItems:'center' }}>

        {/* Text */}
        <div>
          <Label>01 · KERNFEATURE</Label>
          <h2 style={{ fontFamily:D, fontWeight:900, fontStyle:'italic', fontSize:'clamp(40px, 5vw, 60px)', lineHeight:0.92, textTransform:'uppercase', margin:'0 0 28px', color:TEXT }}>
            Race<br /><span style={{ color:C }}>Matrix</span>
          </h2>
          <p style={{ fontFamily:P, fontSize:15, color:TEXT_MID, lineHeight:1.85, margin:'0 0 32px' }}>
            Alle Events. Alle Fahrer. Ein Blick. Wer fährt, wer passt, wer noch nicht geantwortet hat — ohne eine einzige WhatsApp-Nachricht.
          </p>
          <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
            {[
              ['1-Tap Status',     'Fahrer bestätigen oder absagen in einer Sekunde'],
              ['Echtzeit-Übersicht','Teammanager sieht sofort den aktuellen Stand'],
              ['Mobile First',     '"Ich"-Tab für meine Events, "Team"-Tab für den Überblick'],
            ].map(([t, d]) => (
              <div key={t} style={{ display:'flex', gap:14, alignItems:'flex-start' }}>
                <div style={{ width:7, height:7, borderRadius:'50%', background:C, marginTop:6, flexShrink:0 }} />
                <div>
                  <div style={{ fontFamily:P, fontSize:13, fontWeight:700, color:TEXT, letterSpacing:'0.06em' }}>{t}</div>
                  <div style={{ fontFamily:P, fontSize:12, color:TEXT_DIM, marginTop:3, lineHeight:1.6 }}>{d}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop:28, fontFamily:P, fontSize:11, color:`${C}88`, letterSpacing:'0.12em' }}>
            ↓ DIREKT AUSPROBIEREN — AN-/ABMELDEN IM MOCK
          </div>
        </div>

        {/* Interactive Mock */}
        <div style={{ position:'relative' }}>
          <Brackets size={18} color={`${C}55`} />
          <div style={{ background:'#FFFFFF', border:`1px solid ${C}33`, boxShadow:`0 4px 24px rgba(0,168,180,0.08)` }}>
            <div style={{ padding:'14px 18px', borderBottom:`1px solid rgba(0,168,180,0.2)`, display:'flex', alignItems:'center', gap:10, background:'#F3F6F7' }}>
              <div style={{ fontFamily:P, fontSize:10, fontWeight:700, letterSpacing:'0.14em', color:C }}>RACE MATRIX · SAISON 2026</div>
              <div style={{ marginLeft:'auto', display:'flex', gap:6 }}>
                {['ICH','TEAM'].map((t,i) => (
                  <div key={t} style={{ fontFamily:P, fontSize:9, fontWeight:700, letterSpacing:'0.1em', padding:'3px 11px', background: i===0 ? C : 'transparent', color: i===0 ? '#ffffff' : TEXT_DIM, border:`1px solid ${i===0 ? C : 'rgba(0,168,180,0.25)'}` }}>{t}</div>
                ))}
              </div>
            </div>

            {events.map((ev) => {
              const confirmed = ev.myStatus === 'confirmed';
              return (
                <div key={ev.id} style={{ padding:'16px 18px', borderBottom:'1px solid rgba(0,168,180,0.12)', background: confirmed ? `${C}10` : 'transparent', transition:'background 0.2s' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:10 }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontFamily:D, fontStyle:'italic', fontWeight:800, fontSize:14, color:TEXT, textTransform:'uppercase', letterSpacing:'0.04em' }}>{ev.name}</div>
                      <div style={{ fontFamily:P, fontSize:10, color:TEXT_MID, marginTop:2 }}>{ev.date}</div>
                    </div>
                    {/* Driver avatars */}
                    <div style={{ display:'flex' }}>
                      {ev.drivers.slice(0,4).map((ini,j) => (
                        <div key={j} style={{ width:26, height:26, borderRadius:'50%', border:`1.5px solid ${COLORS[j%COLORS.length]}`, background:'rgba(30,34,38,0.9)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:D, fontSize:10, fontWeight:800, color:COLORS[j%COLORS.length], marginLeft: j>0 ? -8 : 0 }}>{ini}</div>
                      ))}
                      {ev.drivers.length > 4 && <div style={{ width:26, height:26, borderRadius:'50%', border:`1.5px solid ${C}44`, background:'#F3F6F7', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:P, fontSize:9, color:TEXT_MID, marginLeft:-8 }}>+{ev.drivers.length-4}</div>}
                    </div>
                  </div>
                  {/* Clickable toggle */}
                  <button onClick={() => toggle(ev.id)} style={{
                    width:'100%', padding:'9px 0', fontFamily:P, fontSize:11, fontWeight:700, letterSpacing:'0.12em',
                    background: confirmed ? `${C}18` : 'rgba(255,154,31,0.1)',
                    border: `1px solid ${confirmed ? `${C}55` : 'rgba(255,154,31,0.4)'}`,
                    color: confirmed ? C : '#ff9a1f',
                    cursor:'pointer', transition:'all 0.18s',
                  }}>
                    {confirmed ? '✓ DABEI — KLICK ZUM ABMELDEN' : '— NICHT ANGEMELDET — KLICK ZUM ANMELDEN'}
                  </button>
                </div>
              );
            })}
            <div style={{ padding:'10px 18px', fontFamily:P, fontSize:9, color:TEXT_DIM, letterSpacing:'0.1em', borderTop:'1px solid rgba(0,168,180,0.12)' }}>
              LIVE SIMULATION · KEIN ACCOUNT NÖTIG
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── Feature Grid ──────────────────────────────────────────────────────────────
const FEATURES = [
  {
    tag:'02', title:'Punkteübersicht',
    desc:'Punkte und Rangliste werden automatisch synchronisiert. Saisonverlauf pro Fahrer als Chart. Vergangene Saisons bleiben als Archiv erhalten.',
    highlights:['Automatischer Punktesync','Saisonverlauf-Chart','Jahresarchiv'],
  },
  {
    tag:'03', title:'Push-Notifications',
    desc:'Anmeldeschluss naht? Alle Fahrer bekommen eine Push-Notification direkt auf den Sperrbildschirm — nicht im Chat-Rauschen verloren.',
    highlights:['Event-Reminder','Anmeldeschluss-Alert','Einladungen'],
  },
  {
    tag:'04', title:'Kalenderintegration',
    desc:'Rennen in Sekunden zum Kalender hinzufügen. Events landen automatisch in Apple-Kalender, Google Calendar oder Outlook — einmal einrichten, immer aktuell.',
    highlights:['Apple · Google · Outlook','Automatisch aktuell','Ein Klick'],
  },
  {
    tag:'05', title:'Fahrgemeinschaft',
    desc:'Wer fährt mit wem? Fahrgemeinschaften direkt in der Event-Ansicht koordinieren — kein separater Gruppenthread nötig.',
    highlights:['Koordination pro Event','Sofort sichtbar','Im Detail verwalten'],
  },
  {
    tag:'06', title:'Öffentliche Team-Seite',
    desc:'Jedes Team bekommt eine öffentliche URL mit Punktestand, Events und Fahrerübersicht. Als Marketing-Tool für neue Mitglieder und Sponsoren.',
    highlights:['Eigene Team-URL','Live Punkte-Chart','Startliste pro Event'],
  },
  {
    tag:'07', title:'Whitelabel-Theming',
    desc:'Teamfarben, Logo, eigene URL. Das Tool sieht nach eurem Team aus — nicht nach fremder Software. Vollständig anpassbar.',
    highlights:['Primär- & Sekundärfarbe','Team-Logo','Eigene URL'],
  },
];

function FeaturesGrid() {
  return (
    <section style={{ padding:'110px 24px', background:BG, position:'relative' }}>
      <div style={{ position:'absolute', inset:0, backgroundImage:`linear-gradient(${C}10 1px,transparent 1px),linear-gradient(90deg,${C}10 1px,transparent 1px)`, backgroundSize:'48px 48px', pointerEvents:'none' }} />
      <div style={{ maxWidth:1040, margin:'0 auto', position:'relative', zIndex:1 }}>
        <div style={{ textAlign:'center', marginBottom:64 }}>
          <Label style={{ display:'flex', justifyContent:'center' }}>FEATURES</Label>
          <h2 style={{ fontFamily:D, fontWeight:900, fontStyle:'italic', fontSize:'clamp(36px, 5vw, 52px)', textTransform:'uppercase', margin:0, color:TEXT, lineHeight:1 }}>
            Alles was ein<br /><span style={{ color:C }}>Crit-Team braucht.</span>
          </h2>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:1, background:`rgba(0,168,180,0.15)` }}>
          {FEATURES.map(f => (
            <div key={f.tag} style={{ background:'#FFFFFF', padding:'34px 30px', position:'relative', transition:'background 0.2s' }}
              onMouseEnter={e=>e.currentTarget.style.background=`${C}0A`}
              onMouseLeave={e=>e.currentTarget.style.background='#FFFFFF'}>
              <div style={{ fontFamily:P, fontSize:9, fontWeight:700, letterSpacing:'0.18em', color:C, marginBottom:10 }}>{f.tag}</div>
              <div style={{ fontFamily:D, fontWeight:800, fontStyle:'italic', fontSize:22, textTransform:'uppercase', letterSpacing:'0.04em', color:TEXT, marginBottom:14 }}>{f.title}</div>
              <p style={{ fontFamily:P, fontSize:13, color:TEXT_MID, lineHeight:1.9, margin:'0 0 18px' }}>{f.desc}</p>
              <div style={{ display:'flex', flexWrap:'wrap', gap:5 }}>
                {f.highlights.map(h => <span key={h} style={{ fontFamily:P, fontSize:10, fontWeight:700, letterSpacing:'0.08em', padding:'3px 9px', border:`1px solid ${C}44`, color:C }}>{h}</span>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Onboarding Strip ──────────────────────────────────────────────────────────
function OnboardingStrip() {
  const steps = [
    { n:'01', title:'Team registrieren', desc:'Name, E-Mail, Passwort. 60 Sekunden.' },
    { n:'02', title:'Fahrer einladen',   desc:'Einladungslink teilen oder direkt einladen.' },
    { n:'03', title:'Erstes Event',      desc:'Datum, Ort, Anmeldeschluss — fertig.' },
    { n:'04', title:'Punkte-Sync starten', desc:'Punkte und Rangliste werden automatisch importiert.' },
  ];
  return (
    <section style={{ padding:'100px 24px', background:'#FFFFFF' }}>
      <div style={{ maxWidth:1000, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:60 }}>
          <Label style={{ display:'flex', justifyContent:'center' }}>SO GEHT'S</Label>
          <h2 style={{ fontFamily:D, fontWeight:900, fontStyle:'italic', fontSize:'clamp(32px, 4vw, 48px)', textTransform:'uppercase', margin:0, color:TEXT }}>
            In 10 Minuten<br /><span style={{ color:C }}>startklar.</span>
          </h2>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:0, position:'relative' }}>
          <div style={{ position:'absolute', top:24, left:'12.5%', right:'12.5%', height:1, background:`linear-gradient(90deg,transparent,${C}66 20%,${C}66 80%,transparent)`, zIndex:0 }} />
          {steps.map((s,i) => (
            <div key={i} style={{ textAlign:'center', padding:'0 20px', position:'relative', zIndex:1 }}>
              <div style={{ width:48, height:48, borderRadius:'50%', border:`2px solid ${C}`, background:'#FFFFFF', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 22px', fontFamily:P, fontSize:13, fontWeight:700, color:C }}>{s.n}</div>
              <div style={{ fontFamily:D, fontWeight:800, fontStyle:'italic', fontSize:16, textTransform:'uppercase', letterSpacing:'0.06em', color:TEXT, marginBottom:10 }}>{s.title}</div>
              <div style={{ fontFamily:P, fontSize:12, color:TEXT_DIM, lineHeight:1.7 }}>{s.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Final CTA ─────────────────────────────────────────────────────────────────
function FinalCTA() {
  return (
    <section style={{ padding:'130px 24px', background:BG, position:'relative', overflow:'hidden', textAlign:'center' }}>
      <div style={{ position:'absolute', inset:0, background:`radial-gradient(ellipse at 50% 60%,${C}18 0%,transparent 65%)`, pointerEvents:'none' }} />
      <div style={{ position:'absolute', inset:0, backgroundImage:`linear-gradient(${C}10 1px,transparent 1px),linear-gradient(90deg,${C}10 1px,transparent 1px)`, backgroundSize:'60px 60px', pointerEvents:'none' }} />
      <div style={{ position:'relative', zIndex:1, maxWidth:680, margin:'0 auto' }}>
        <Label style={{ display:'flex', justifyContent:'center' }}>JETZT STARTEN</Label>
        <h2 style={{ fontFamily:D, fontWeight:900, fontStyle:'italic', fontSize:'clamp(42px, 6vw, 72px)', lineHeight:0.92, textTransform:'uppercase', margin:'0 0 28px', color:TEXT }}>
          Bereit für das<br /><span style={{ color:C }}>nächste Rennen?</span>
        </h2>
        <p style={{ fontFamily:P, fontSize:14, color:TEXT_MID, letterSpacing:'0.05em', lineHeight:1.8, margin:'0 auto 44px', maxWidth:460 }}>
          Kostenlos registrieren. Kein Kreditkartenzwang.<br />In 10 Minuten startklar.
        </p>
        <Link to="/login" style={{ fontFamily:P, fontSize:15, fontWeight:700, letterSpacing:'0.16em', background:C, color:'#ffffff', padding:'20px 48px', textDecoration:'none', display:'inline-block', boxShadow:`0 4px 24px ${C}55` }}>
          KOSTENLOS STARTEN →
        </Link>
        <div style={{ marginTop:20, fontFamily:P, fontSize:11, color:TEXT_DIM, letterSpacing:'0.08em' }}>
          Kein Kreditkartenzwang · Made for Crit Teams
        </div>
      </div>
    </section>
  );
}

// ── Footer ────────────────────────────────────────────────────────────────────
function Footer() {
  return (
    <footer style={{ background:'#E8EEEF', borderTop:`1px solid ${C}22`, padding:'30px 32px' }}>
      <div style={{ maxWidth:1000, margin:'0 auto', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <BrandMark size={22} variant="on-light" style={{ opacity: 0.6 }} />
          <span style={{ fontFamily:P, fontSize:11, fontWeight:700, letterSpacing:'0.12em', color:TEXT_DIM }}>CRIT ROSTER · critroster.cc</span>
        </div>
        <div style={{ display:'flex', gap:24 }}>
          {[['Login','/login'],['Team starten','/login'],['Impressum','/impressum'],['Datenschutz','/datenschutz']].map(([label,to]) => (
            <Link key={label} to={to} style={{ fontFamily:P, fontSize:11, letterSpacing:'0.08em', color:TEXT_DIM, textDecoration:'none' }}
              onMouseEnter={e=>e.target.style.color=C} onMouseLeave={e=>e.target.style.color=TEXT_DIM}>{label}</Link>
          ))}
        </div>
      </div>
    </footer>
  );
}

// ── Page ──────────────────────────────────────────────────────────────────────
export default function LandingPage() {
  useEffect(() => {
    document.title = 'Crit Roster — Team-Management für Criterium-Teams';
    return () => { document.title = 'Crit Roster'; };
  }, []);
  return (
    <div data-theme="light" style={{ background:BG, color:TEXT, minHeight:'100vh', overflowX:'hidden' }}>
      <Nav />
      <Hero />
      <ProblemStrip />
      <RaceMatrixSection />
      <FeaturesGrid />
      <OnboardingStrip />
      <FinalCTA />
      <Footer />
    </div>
  );
}
